import { FC, ReactElement } from "react";
import { 
    Box, 
    Button, 
    Typography, 
    useTheme 
} from "@mui/material";
import { 
    CheckCircle,
    CancelRounded 
} from "@mui/icons-material";
import { LazyTooltip } from "./ToolTip";
import { useReportsConfirmed } from "../../hooks";

interface ProjectManagerProps {
    label: string,
    title: string,
    imageSrc?: string,
    disabled: boolean,
    handleReportConfirm: () => void,
    confirmed: string,
    confirmDate?: string,
    marginLeft?: number
}
export const ReportConfirm: FC<ProjectManagerProps> = ({ 
    label, 
    title,
    // imageSrc, 
    disabled, 
    handleReportConfirm,
    confirmed,
    confirmDate='',
    marginLeft,
}): ReactElement => {
    const theme = useTheme();
    const { checkConfirmation } = useReportsConfirmed()
    const { isReportConfirmed } = checkConfirmation(0);
    
    const managerConfirmed = isReportConfirmed === 'confirmed';
    const confirmMessage =  " تاریخ تائید: " + confirmDate ;

    return (
        <Box 
          display='flex' 
          justifyContent='space-between' 
          maxWidth={400} 
          borderRadius={2} 
          boxShadow={3} 
          sx={{
            bgcolor:theme.palette.background.paper,
            direction:'rtl',
            marginLeft: marginLeft
          }} 
        >
            <Box display='flex' flexDirection='column' justifyContent='end' mx={1} my={1}>
            {
                confirmed === "confirmed" ? 
                    <LazyTooltip placement="bottom" title={confirmMessage}>
                        <CheckCircle 
                            sx={{
                                display: { xs: "none", md: "flex" }, 
                                width:30, 
                                height:30,
                                color:!managerConfirmed ? "yellow" : "green",
                            }}
                        />
                    </LazyTooltip>
                :
                    <LazyTooltip placement="bottom" title="گزارش این ماه تائید نگردیده است">
                        <CancelRounded 
                            sx={{
                                display: { xs: "none", md: "flex" }, 
                                width:30, 
                                height:30,
                                color:"red",
                            }}
                        />
                    </LazyTooltip>
            }
            </Box>
            <Box display='flex' flexDirection='column' alignItems='center' mx={2} my={1}>
                <Typography variant='body1' fontFamily='B Nazanin'>
                    تنظیم کننده : {label}
                </Typography>
                <Button 
                    color="success"
                    variant="contained"
                    disabled={disabled} 
                    onClick={handleReportConfirm} 
                    sx={{ fontFamily:'B Nazanin'}} 
                >
                    تائید {title}
                </Button>
            </Box>
            {/* <ManageAccountsRounded color="action" sx={{ display: { xs: "none", md: "flex" }, mx:1, my:'auto', width:45, height:45,  }}/> */}
        </Box>
    )
}

